import axios from 'axios';



const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,   // ⭐ dynamic URL (Render or local)
  withCredentials: true,                    // optional if you use cookies
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token){
     config.headers.Authorization = `Bearer ${token}`;
    }
  return config;
},
(error) => Promise.reject(error));

export default axiosInstance;
